module.exports = __webpack_public_path__ + "img/shop7.4d303dfa.png";